import React from 'react';

function Loading() {
  return (
    <div className="login-container">
      <div style={{ textAlign: 'center' }}>
        <div className="logo-circle" style={{ margin: '0 auto 1.5rem', width: '60px', height: '60px', fontSize: '1.5rem', border: '2px solid rgba(251,191,36,0.3)' }}>
          ⌛
        </div>
        <h3 style={{ color: '#fbbf24', letterSpacing: '2px' }}>Carregando...</h3>
      </div>
    </div>
  );
}

export default Loading;
